import { createSelector } from 'reselect';

const selectTrimming = state => state.trimming;

export const selectSendingNewTrim = createSelector(
  selectTrimming,
  trimming => trimming.sendingNewTrim
);
